import { reactive } from 'vue'
import StorageService from '@/services/StorageService'
import LocalesService from '@/services/LocalesService'
import NotificationsService from '@/services/NotificationsService.js'

const key = 'settings'

function defaultStore () {
  return {
    sound: true,
    vibration: true,
    language: null,
    notifications: null,

    // Dynamic parameters
    parameters: {
      seenGameUnlockedNotice: false,
      seenTutorials: false,
      seenLeverageTip: false,
      seenFeedbackRequest: false
    }
  }
}

const store = reactive(defaultStore())

async function persist () {
  await StorageService.set(key, store)
}

const Settings = {
  key,

  getStore () {
    return store
  },

  setStore (d = {}) {
    Object.assign(store, d)
  },

  async reset () {
    Object.assign(store, defaultStore())
    await StorageService.delete(key)
  },

  getSound () {
    return store.sound
  },

  getVibration () {
    return store.vibration
  },

  getNotifications () {
    return store.notifications
  },

  getLanguage () {
    return store.language
  },

  toggleSound () {
    store.sound = !store.sound
    return persist()
  },

  toggleVibration () {
    store.vibration = !store.vibration
    return persist()
  },

  async enableNotifications (enabled) {
    if (enabled) {
      await NotificationsService.init()
    } else {
      await NotificationsService.unregisterPushNotifications()
    }

    store.notifications = NotificationsService.registered
    await persist()
  },

  async setLanguage (val) {
    await LocalesService.setAppLanguage(val)
    store.language = val
    return persist()
  },

  getParam (key, defaultValue) {
    return store.parameters[key] === undefined ? defaultValue : store.parameters[key]
  },

  setParam (key, val) {
    store.parameters[key] = val
    return persist()
  }
}

export default Settings
